// extracted by mini-css-extract-plugin
export var container = "TextInnerLink-module--container--d9482";
export var disabled = "TextInnerLink-module--disabled--407fa";
export var icon = "TextInnerLink-module--icon--8ab02";
export var textSizeXxs = "TextInnerLink-module--textSizeXxs--47bde";